module.exports = __webpack_public_path__ + "static/media/Nuria-Coll-Theme.4642d526.png";